import { DocumentChangedInfo, StateChangeInfo } from '@formbird/types';

export interface IFormNewState {
  canUndo: boolean,
  canRedo: boolean,
  documents: any, // list of documents on forms
  orgDocuments: any, // cached documents - they will be used as original ones
  documentInfo: any, // list of hierarchy documents
  documentChangedInfo: DocumentChangedInfo,
  recordedStateChanges: StateChangeInfo,
  recordedDisableSaveFieldValues: any,
  documentSession: any;
}

export function getDefaultFormNewState(): IFormNewState {
  return {
    canUndo: false,
    canRedo: false,
    documents: {},
    orgDocuments: {},
    documentInfo: {},
    documentChangedInfo: null,
    recordedStateChanges: null,
    recordedDisableSaveFieldValues: {},
    documentSession: {}
  };
}
